/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/**
 * AccountService APIs
 */

import addAddressBookV2 from './addAddressBookV2';
import getAllAddressBookV2 from './getAllAddressBookV2';
import updateAddressBookV2 from './updateAddressBookV2';
import removeAddressBookV2 from './removeAddressBookV2';

import getAllAddressBook from './getAllAddressBook';
import getBillingUserAddressBook from './getBillingUserAddressBook';
import updateAddressBook from './updateAddressBook';
import removeAddressBook from './removeAddressBook';
import saveAddressBook from './saveAddressBook';

const addressBookServiceClient = {
    addAddressBookV2,
    getAllAddressBookV2,
    updateAddressBookV2,
    removeAddressBookV2,

    saveAddressBook,
    getAllAddressBook,
    getBillingUserAddressBook,
    removeAddressBook,
    updateAddressBook,
};

export default addressBookServiceClient;
